export default __webpack_public_path__ + "static/media/immunity-1.3bd705f3.png";